<template>
  <div>
    <v-card
      elevation="1"
      class="ml-md-5 mt-5 mx-auto light-blue"
      @click.stop="dialog = true"
    >
      <v-img class="align-end" src="@/assets/images/vibg.png" height="150px">
      </v-img>
      <h2 class="text-h6 white--text text-center font-weight-medium pa-2">
        {{ $t("string612") }}
      </h2>
    </v-card>
    <v-dialog v-model="dialog" max-width="100%" width="800px">
      <v-card>
        <v-toolbar elevation="0">
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="dialog = false">
            {{ $t("Close") }}
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-carousel class="mt-5 mb-5" height="480">
            <v-carousel-item v-for="item in yData" :key="item._id">
              <youtube
                :video-id="getVideoId(item)"
                player-width="100%"
                player-height="480px"
              ></youtube>
            </v-carousel-item>
            <v-carousel-item v-for="item in vData" :key="item._id">
              <video width="100%" controls>
                <source
                  :src="$store.state.videoUrl + 'files/' + item.file"
                  type="video/ogg"
                />
                <source
                  :src="$store.state.videoUrl + 'files/' + item.file"
                  type="video/mp4"
                />
                <source
                  :src="$store.state.videoUrl + 'files/' + item.file"
                  type="video/webm"
                />
                Your browser does not support the video tag.
              </video>
            </v-carousel-item>
          </v-carousel>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "VideoTourDialog",
  props: ["yData", "vData"],
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    getVideoId(val) {
      return this.$youtube.getIdFromURL(val.toString());
    }
  }
};
</script>

<style></style>
